import React, { useState, useEffect } from "react";
import TaskImageSlider from "../modals/TaskImageSlider";
import { useHistory } from "react-router-dom";
import ChildPic from "../../../../assets/images/child.jpg";
import {
  taskList as taskListApi,
  setTaskList,
  removeTaskItems,
  taskDelete,
  completedTask,
} from "../../AxiosRtk/Tasks";
import { useSelector, useDispatch } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import TaskRow from "./TaskRow";
import moment from "moment";
// import Swal from "sweetalert2";
// import { AlertModal } from "../../../../setup/alert/swalAlert";
// import { alertIconType } from "../../../../setup/alert/iconTypes";
import useSubscription from "../../../customHooks/subscriptionProvider";
import { setShowInfo, setErrorInfo } from "../../AxiosRtk/successMessage";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import DeleteTasks from "../modals/DeleteTasks";
// import DeletedSuccessfully from "../modals/DeletedSuccessfully";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import InfoTaskMarkComplete from "../modals/InfoTaskMarkComplete";
import Select from "react-select";
import useDurationOption from "../../../customHooks/durationOption";
import KidImage from "../../../shared/KidImage/KidImage";
import { deviceSelected, setSelectedKidId } from "../../AxiosRtk/DashBoard";

const Tasks = () => {
  const [showModal, setShowModal] = useState(false);
  const { selectedKidId, kidList, selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
  const [isDisabled, setIsDisabled] = useState(true);

  const [kidChangeTo, setKidChangeTo] = useState(selectedKidId);

  const [kid, setKid] = useState(null);
  const [deleteTaskModal, setDeleteTaskModal] = useState(false);
  const [infoConfirmModal, setInfoConfirmModal] = useState(false);
  const [dateFilter, setDateFilter] = useState("Today");
  const [statusFilter, setStatusFilter] = useState("");
  const [delCompLoader, setDelCompLoader] = useState({
    del: false,
    comp: false,
  });
  const { durationOptionsFunction, statusOptionFunction } = useDurationOption();

  const [selectedDuration, setSelectedDuration] = useState(1);
  const statusOptions = statusOptionFunction();
  const durationOptions = durationOptionsFunction();
  const { getImage } = useKidListFunctionality();

  const [loader, setLoader] = useState(false);
  const [imgArr, setImgArr] = useState([]);
  // const openModal = () => { setShowModal(true); };
  const closeModal = () => {
    setShowModal(false);
  };
  const history = useHistory();
  const dispatch = useDispatch();

  const { getLangTranslation } = useLangTranslation();
  const { taskList } = useSelector(({ tasks }) => tasks);

  const { checkSubsciption } = useSubscription();

  function getTaskListApi() {
    let beginTime = moment().locale("en").format("YYYY-MM-DD");
    let endTime = moment().locale("en").format("YYYY-MM-DD");

    if (dateFilter === "1_WEEK") {
      beginTime = moment()
        .locale("en")
        .subtract(6, "days")
        .format("YYYY-MM-DD");
    } else if (dateFilter === "2_WEEK") {
      beginTime = moment()
        .locale("en")
        .subtract(13, "days")
        .format("YYYY-MM-DD");
    } else if (dateFilter === "1_MONTH") {
      beginTime = moment()
        .locale("en")
        .subtract(29, "days")
        .format("YYYY-MM-DD");
    }

    const payload = {
      pageOffset: 1,
      pageLimit: 500,
      kidId: selectedKidId,
      startDate: beginTime,
      endDate: endTime,
      taskStatus: statusFilter,
    };

    if (statusFilter === "") {
      delete payload.taskStatus;
    }

    if (dateFilter === "ALL") {
      delete payload.startDate;
      delete payload.endDate;
    }

    setLoader(true);
    dispatch(removeTaskItems("TASKS"));
    taskListApi(payload)
      .then((res) => {
        const modfiedRes = res?.data?.result?.map((item) => {
          return {
            ...item,
            isChecked: false,
          };
        });
        dispatch(setTaskList(modfiedRes));
      })
      .catch((err) => {
        console.log("task list catch error ==>>", err?.response?.data?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  useEffect(() => {
    if (selectedKidId) {
      getTaskListApi(); // Trigger API call when selectedKidId changes
      const kidData = kidList?.find(
        (item) => parseInt(item?.ID) === parseInt(selectedKidId)
      );
      setKid(kidData); // Update kid data based on selectedKidId
    }
  }, [selectedKidId, dateFilter, statusFilter]);

  function handleImageClick(taskId) {
    if (!checkSubsciption()) {
      return;
    }
    setImgArr([]);
    const selectTask = taskList?.find((element) => element?.ID === taskId);
    const imgArr = selectTask?.fileUpload
      ? selectTask?.fileUpload?.split(",")
      : [];
    setImgArr(imgArr);
    setShowModal(true);
  }

  function handleSelectChange(e) {
    const { name, checked } = e.target;
    let tempTaskList = [];
    if (name === "ALL_SELECT") {
      tempTaskList = taskList?.map((item, index) => {
        return {
          ...item,
          isChecked: checked,
        };
      });
    } else {
      tempTaskList = taskList?.map((item, index) =>
        item?.ID === parseInt(name)
          ? {
            ...item,
            isChecked: checked,
          }
          : item
      );
    }

    dispatch(setTaskList(tempTaskList));
  }

  function handleDeleteModalOpen() {
    if (!checkSubsciption()) {
      return;
    }

    const taskIds = [];
    taskList?.forEach((item) => {
      if (item?.isChecked) {
        taskIds.push(item?.ID);
      }
    });
    if (taskIds?.length === 0) {
      return;
    }

    setDeleteTaskModal(true);
  }

  function handleDeleteTask() {
    if (!checkSubsciption()) {
      return;
    }

    const taskIds = [];
    taskList?.forEach((item) => {
      if (item?.isChecked) {
        taskIds.push(item?.ID);
      }
    });
    if (taskIds?.length === 0) {
      return;
    }
    setDelCompLoader({
      ...delCompLoader,
      del: true,
    });

    let payload = null;
    if (taskIds?.length === 1) {
      payload = {
        ID: taskIds[0],
      };
    } else {
      payload = { deleteIds: [...taskIds] };
    }
    taskDelete(payload)
      .then(() => {
        setTimeout(() => {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: "Task has been deleted successfully.",
              message: "TASK_DELETED",
            })
          )
        }, 800)
        // dispatch(
        //   setShowMessage({
        //     showMessage: true,
        //     defaultMessage: "Task has been deleted successfully.",
        //     message: "TASK_DELETED",
        //   })
        // );
        getTaskListApi();
      })
      .catch((err) => {
        dispatch(
          setErrorInfo({
            errorInfo: true,
            title: err?.response?.data?.message,
            defaultTitle: err?.response?.data?.message,
          })
        );
        // AlertModal(
        //   err?.response?.data?.message,
        //   alertIconType?.errorIcon,
        //   true
        // )
      })
      .finally(() => {
        setDelCompLoader({
          ...delCompLoader,
          del: false,
        });
        setDeleteTaskModal(false);
      });
  }

  // function handleMarkAsConfirmed() {
  //   if (!checkSubsciption()) {
  //     return;
  //   }
  //   const taskIds = [];
  //   taskList?.forEach((item) => {
  //     if (item?.isChecked) {
  //       taskIds.push(item?.ID);
  //     }
  //   });
  //   if (taskIds?.length === 0) {
  //     return;
  //   }
  //   setDelCompLoader({
  //     ...delCompLoader,
  //     comp: true,
  //   });
  //   Swal.fire({
  //     icon: "question",
  //     title: getLangTranslation("ARE_YOU_SURE_WANT_TO_MASK_TASK_READ_TXT"),
  //     showCancelButton: true,
  //     confirmButtonText: "Yes"
  //   })
  //     .then((res) => {
  //       let payload = null;
  //       if (taskIds?.length === 1) {
  //         payload = {
  //           kidId: kidChangeTo,
  //           taskId: taskIds[0],
  //         };
  //       } else {
  //         payload = { taskIds: [...taskIds] };
  //       }
  //       completedTask(payload)
  //         .then(() => {
  //           getTaskListApi();
  //         })
  //         .catch((err) => {
  //           // AlertModal(
  //           //   err?.response?.data?.message,
  //           //   alertIconType?.errorIcon,
  //           //   true
  //           // );
  //           dispatch(
  //             setErrorInfo({
  //               errorInfo: true,
  //               title: err?.response?.data?.message,
  //               defaultTitle: err?.response?.data?.message
  //             })
  //           );
  //         });
  //     })
  //     .catch((err) => {
  //       console.log(
  //         "mark as completed task catch error ==>>",
  //         err?.response?.data?.message
  //       );
  //     })
  //     .finally(() => {
  //       setDelCompLoader({
  //         ...delCompLoader,
  //         comp: false,
  //       });
  //     });
  // }

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  useEffect(() => {
    // Disable the button if no device is available
    if (!isDevicesAvailable) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [isDevicesAvailable]);

  // function handleCreateNewTask() {
  //   if (!checkSubsciption()) {
  //     return;
  //   }
  //   // if (!selectedKidId) {
  //   //   {
  //   //     /*  AlertModal(
  //   //     getLangTranslation("Please_select_your_child"),
  //   //     alertIconType?.infoIcon,
  //   //     true
  //   // );*/
  //   //   }

  //   //   dispatch(
  //   //     setShowInfo({
  //   //       showInfo: true,
  //   //       title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
  //   //       defaultMessage: "Please select a child",
  //   //       message: "SELECT_CHILD_PLEASE_SELECT_A_CHILD",
  //   //     })
  //   //   );
  //   //   return;
  //   // }
  //   // if (isDisabled) {
  //   //   history.push("/create-new-task");
  //   // }

  //   if (!selectedDeviceData) {
  //     dispatch(
  //       setShowInfo({
  //         showInfo: true,
  //         title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
  //         defaultTitle: "Please select device",
  //       })
  //     );
  //     return; 
  //   }
  //   if (!isDisabled) {
  //     history.push({
  //       pathname: "/create-new-task",
  //       state: { previousPage: "ACTIVITY" },
  //     })
  //   }

  // }
  function handleCreateNewTask() {
    if (!checkSubsciption()) {
      return;
    }

    if (!selectedKidId) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select a child",
        })
      );
      return;
    }

    if (!isDevicesAvailable) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Selected child doesn't have a device assigned",
        })
      );
      return;
    }
    if (!isDisabled) {
      history.push({
        pathname: "/create-new-task",
        state: { previousPage: "ACTIVITY" },
      });
    }
  }

  function handleBack() {
    history.goBack();
  }

  function handleConfirmedModalOpen() {
    if (!checkSubsciption()) {
      return;
    }
    const taskIds = [];
    taskList?.forEach((item) => {
      if (item?.isChecked) {
        taskIds.push(item?.ID);
      }
    });
    if (taskIds?.length === 0) {
      return;
    }
    setInfoConfirmModal(true);
  }

  function handleInfoTaskMarkSave() {
    const taskIds = [];
    taskList?.forEach((item) => {
      if (item?.isChecked) {
        taskIds.push(item?.ID);
      }
    });
    if (taskIds?.length === 0) {
      return;
    }

    setDelCompLoader({
      ...delCompLoader,
      comp: true,
    });

    let payload = null;
    if (taskIds?.length === 1) {
      payload = {
        kidId: selectedKidId,
        taskId: taskIds[0],
      };
    } else {
      payload = { kidId: selectedKidId, taskIds: [...taskIds] };
    }
    completedTask(payload)
      .then(() => {
        getTaskListApi();
      })
      .catch((err) => {
        dispatch(
          setErrorInfo({
            errorInfo: true,
            title: err?.response?.data?.message,
            defaultTitle: err?.response?.data?.message,
          })
        );
      })
      .finally(() => {
        setDelCompLoader({
          ...delCompLoader,
          comp: false,
        });
        setInfoConfirmModal(false);
      });
  }
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const [kidListOptions, setkidListOptions] = useState([]);
  useEffect(() => {
    setkidListOptions(
      kidList?.map((item) => {
        return { value: item?.ID, label: item?.childName };
      })
    );
  }, [kidList]);

  const handleKidChange = (selectedOption) => {
    const newKidId = selectedOption.value;
    dispatch(setSelectedKidId(newKidId)); // This updates the Redux state

    // Prepare payload for device selection
    const payload = {
      deviceId: selectedDeviceData?.ID,
      isDeviceSelected: 1,
      kidId: newKidId,
    };

    // Call API to update selected device
    if (payload.deviceId) {
      deviceSelected(payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error('Error updating device selection:', error);
        });
    }
  };

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6">
            <h3 className="text-blue-900 mb-0 c-pointer" onClick={handleBack}>
              {lang?.isRTL === 1 ? (
                <>
                  {getLangTranslation("ALL TASKS", "All Tasks")}{" "}
                  <i className="icon-arrow-right" />
                </>
              ) : (
                <>
                  <i className="icon-arrow-left" />{" "}
                  {getLangTranslation("ALL TASKS", "All Tasks")}
                </>
              )}
            </h3>
            <div className="d-flex align-items-center gap-3 flex-wrap flex-md-nowrap content-550 w-100 justify-content-end">
              <div className="select-with-icon">
                {/* <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                  <img src={getImage(kid?.image, kid?.gender)} alt="" />
                </span> */}
                <KidImage imageUrl={kid?.image} gender={kid?.gender} />
                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  onChange={handleKidChange}
                  options={kidListOptions}
                  value={
                    kidListOptions?.find(
                      (item) => item?.value == selectedKidId // Changed from kidChangeTo
                    ) || ""
                  }
                />
              </div>
              <button
                className="btn btn-outline-primary d-inline-flex align-items-center gap-1"
                type="button"
                onClick={handleCreateNewTask}
              // disabled={isDisabled}
              >
                <i className="icon-plus fs-5" />
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation("CREATE_NEW_TASK", "Create new task")}
                </span>
              </button>
            </div>
          </div>
          <hr className="my-6" />
          <div className="d-flex align-items-center flex-wrap gap-6 mb-6">
            <div className="d-flex align-items-center gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault"
                  name="ALL_SELECT"
                  onChange={handleSelectChange}
                  checked={
                    taskList?.length !== 0 &&
                    taskList?.filter((item) => item?.isChecked === false)
                      .length < 1
                  }
                  disabled={isDisabled || delCompLoader?.comp}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="flexCheckDefault"
                >
                  {getLangTranslation("TASK_HISTORY_SELECT_ALL", "Select All")}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={() => handleDeleteModalOpen()}
                disabled={isDisabled || delCompLoader?.comp}
              >
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation(
                    "TASK_HISTORY_DELETE_SELECTED_BUTTON",
                    "Delete selected"
                  )}
                </span>
              </button>
            </div>
            <div className="d-flex align-items-center gap-3 flex-wrap flex-lg-nowrap justify-content-end flex-fill">

              <Select
                className="custom-select col-sm-2"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  setDateFilter(val.value);
                }}
                options={durationOptions}
                value={
                  durationOptions?.find((item) => item?.value == dateFilter) ||
                  ""
                }
                isDisabled={isDisabled}
              />
              <Select
                className="custom-select col-lg-2"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  setStatusFilter(val.value);
                }}
                options={statusOptions}
                value={
                  statusOptions?.find((item) => item?.value == statusFilter) ||
                  ""
                }
                isDisabled={isDisabled}
              />
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => handleConfirmedModalOpen()}
                disabled={isDisabled || delCompLoader?.comp}
              >
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation("MARK_AS_CONFIRMED", "Mark as confirmed")}
                </span>
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle" scope="col">
                    <div className="form-check">
                      {/* <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                value="" 
                                                id="taskName" 
                                            /> */}
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation(
                          "PARENT_ADD_TASK_TASK_NAME",
                          "Task name"
                        )}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle" scope="col">
                    {getLangTranslation(
                      "PARENT_ADD_TASK_TASK_DETAILS",
                      "Task details"
                    )}
                  </th>
                  <th className="v-middle" scope="col">
                    {getLangTranslation("ALLOTTED_TIME", "Allotted time")}
                  </th>
                  <th className="v-middle" scope="col">
                    {getLangTranslation("CREATION_DATE", "Creation date")}
                  </th>
                  <th className="v-middle" scope="col">
                    {getLangTranslation(
                      "DEVICE_DETAIL_FIND_DEVICE_STATUS",
                      "status"
                    )}
                  </th>
                  <th className="v-middle" scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {taskList?.map((item) => {
                  return (
                    <TaskRow
                      item={item}
                      getLangTranslation={getLangTranslation}
                      handleImageClick={handleImageClick}
                      handleSelectChange={handleSelectChange}
                      kidId={selectedKidId}
                      checkSubsciption={checkSubsciption}
                    />
                  );
                })}
              </tbody>
            </table>

            {loader && (
              <div className="w-100 my-3">
                <LoadingIndicator height={20} width={100} color="#66B5FF" />
              </div>
            )}

            {!loader && taskList?.length === 0 && (
              <div className="w-100 my-3 text-center">
                {getLangTranslation("TASK_NOT_EXISTS", "There is no tasks..")}
              </div>
            )}
          </div>
        </div>
      </div>
      <TaskImageSlider
        showModal={showModal}
        closeModal={closeModal}
        imgArr={imgArr}
        kidChangeTo={selectedKidId}
        getLangTranslation={getLangTranslation}
      />
      <DeleteTasks
        showModal={deleteTaskModal}
        setDeleteTaskModal={setDeleteTaskModal}
        handleDeleteTask={handleDeleteTask}
        loader={loader}
        setLoader={setLoader}
      />
      <InfoTaskMarkComplete
        showModal={infoConfirmModal}
        setInfoConfirmModal={setInfoConfirmModal}
        message="ARE_YOU_SURE_WANT_TO_MASK_TASK_READ_TXT"
        msgTranslate="Are you sure want to mark as completed these Tasks ?"
        getLangTranslation={getLangTranslation}
        handleInfoTaskMarkSave={handleInfoTaskMarkSave}
      />
      {/* <DeletedSuccessfully
        showDeletedModal={showDeletedModal}
        closeDeletedModal={closeDeletedModal}
      /> */}
    </>
  );
};

export default Tasks;
